import { render, staticRenderFns } from "./uploadCoverOrPolicyDialog.vue?vue&type=template&id=d61c446a&scoped=true&"
import script from "./uploadCoverOrPolicyDialog.vue?vue&type=script&lang=js&"
export * from "./uploadCoverOrPolicyDialog.vue?vue&type=script&lang=js&"
import style0 from "./uploadCoverOrPolicyDialog.vue?vue&type=style&index=0&id=d61c446a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61c446a",
  null
  
)

export default component.exports